import { useState, useEffect, useCallback } from 'react'
import { inject, observer } from 'mobx-react'
import { useNavigate, useLocation } from 'react-router-dom'
import {
  PageView,
  LinkInvalid,
  Title,
  Desc,
  Phone,
  ButtonStyled,
  Btn,
} from './index.styled'
import { Box, Text } from '@chakra-ui/react'

import queryString from 'query-string'

import { Input, Invalid } from 'components/form'
import { PrimaryBtn } from 'components/button'
import { useMessage } from 'hooks/ToastMessage'
import { useFirebaseRemoteConfig } from 'hooks/useFirebaseRemoteConfig'
import { config } from 'config'
import { InternationalPhone } from '../InternationalPhone'
import { format } from 'utils'
import { DEFAULT_COUNTRY_PHONE } from 'config/defaultCountry'

const ERROR_EXIST = 'exist'
const ERROR_INVALID = 'invalid'

const PhoneNo = (props) => {
  const location = useLocation()
  const navigate = useNavigate()
  const toastMessage = useMessage()
  const [mobile, setMobile] = useState('')
  const [loading, setLoading] = useState(false)
  const [isInvalid, setIsInvalid] = useState(false)
  const [errorMobile, setErrorMobile] = useState('')
  const [selectedCountry, setSelectedCountry] = useState(DEFAULT_COUNTRY_PHONE)

  const { language } = props
  const {
    lang,
    clientId = '',
    redirectUri = '',
    state = '',
    codeChallenge = '',
  } = queryString.parse(location.search)

  const { data: firebaseConfig } = useFirebaseRemoteConfig([
    { key: 'PHONE_NUMBER_MIN', type: 'number' },
    { key: 'PHONE_NUMBER_MAX', type: 'number' },
  ])

  const onInit = useCallback(() => {
    props.language.setLanguage(lang)
  }, [lang, props.language])

  useEffect(() => {
    onInit()
  }, [onInit])

  const onChangeCountry = (item) => {
    setSelectedCountry(item)
  }

  const onChange = (val) => {
    setMobile(val)
    setIsInvalid(false)
    setErrorMobile('')
  }

  const onSubmit = async () => {
    try {
      setLoading(true)

      const txt = format.removeZeroPrefix(String(mobile))
      const val = `${selectedCountry.phoneCode}${txt}`

      const validateResponse = await props.otp.validateMobileNumber({
        mobile: val,
      })
      const isMobileExist = validateResponse.data?.isMobileExisting
      const isMobileVerify = validateResponse.data?.isMobileVerify
      const isPinExist = validateResponse.data?.isPinExist

      if (isMobileExist && isMobileVerify) {
        setLoading(false)

        const requestOtpResponse = await props.otp.requestOtp({ mobile: val })
        if (requestOtpResponse) {
          navigate('/otp/verify', {
            state: {
              lang,
              clientId,
              redirectUri,
              state,
              codeChallenge,
              mobile: val,
              initialMobile: txt,
              prefix: selectedCountry.phoneCode,
              refCode: requestOtpResponse.refcode,
              isPinExist,
            },
          })
        }
      } else {
        setIsInvalid(true)
        setErrorMobile(ERROR_EXIST)
        setLoading(false)
      }
    } catch (e) {
      setLoading(false)
      // toast({ title: e.toString() })
      if (e.message) {
        toastMessage({ title: e.message })
      } else {
        setErrorMobile(ERROR_INVALID)
      }
    }
  }

  const getInvalid = (errorCase) => {
    switch (errorCase) {
      case ERROR_EXIST: {
        return (
          <LinkInvalid>
            {language.getMsg(
              'This number was not found. You can ',
              'เบอร์นี้ยังไม่เคยสมัครบัญชี คุณสามารถ'
            )}
            <a href={`${config.app.scheme}://createAccount`}>
              {language.getMsg('Register', 'สมัคร')}
            </a>
            {language.getMsg(
              'a new account with this number or try again.',
              'บัญชีใหม่ ด้วยเบอร์นี้ หรือเข้าสู่ระบบอีกครั้ง'
            )}
          </LinkInvalid>
        )
      }
      case ERROR_INVALID:
      default: {
        return (
          <Invalid
            invalid={language.getMsg(
              'This number is invalid. Please try again',
              'เบอร์นี้ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง'
            )}
          />
        )
      }
    }
  }

  const invalid = errorMobile ? getInvalid(errorMobile) : undefined

  const len = format.removeZeroPrefix(String(mobile)).length
  const isDisabled =
    len < firebaseConfig.PHONE_NUMBER_MIN ||
    len > firebaseConfig.PHONE_NUMBER_MAX

  console.log('render', mobile)
  return (
    <PageView>
      <Title>
        {language.getMsg('Verify your account', 'ยืนยันบัญชีของคุณ')}
      </Title>
      <Desc>
        {language.getMsg(
          'Please enter your number to request OTP.',
          'กรอกหมายเลขโทรศัพท์ของคุณเพื่อรับ OTP'
        )}
      </Desc>

      <Box position="relative">
        <Text mb={1} color={'#323a43'}>
          {language.getMsg('Mobile number', 'เบอร์โทรศัพท์')}
        </Text>
        <Phone>
          <Input
            type="tel"
            label={language.getMsg(
              'Enter the number for OTP',
              'กรอกเบอร์เพื่อรับรหัสยืนยัน'
            )}
            value={mobile}
            onChange={onChange}
            isNumber
            invalid={isInvalid}
            rightComponent={
              <Box margin="6px 0 6px -10px">
                <InternationalPhone onChange={onChangeCountry} />
              </Box>
            }
            containerStyled={{
              background: 'none',
            }}
            inputStyled={{
              background: 'none',
            }}
          />
        </Phone>
      </Box>
      {invalid}

      <ButtonStyled>
        <Btn>
          <PrimaryBtn
            loading={loading}
            text={language.getMsg('Request OTP', 'ขอรหัส OTP')}
            disabled={isDisabled}
            onClick={onSubmit}
          />
        </Btn>
      </ButtonStyled>
    </PageView>
  )
}

export default inject('otp', 'language')(observer(PhoneNo))
